module.exports = __webpack_public_path__ + "aff9e751749697bcbfe5b30451364cc0.png";